<article class="text-[#353C40] flex flex-col gap-1 overflow-hidden">
  <h3
    class="text-center text-[1.6rem] font-semibold leading-7 flex flex-col break-words min-w-0">
    Helpful Resources
  </h3>
  <h4
    class="text-center text-[.8rem] font-medium leading-7 flex flex-col break-words min-w-0">
    Review these links if you need guidance before continuing.
  </h4>
</article>
